// extracted by mini-css-extract-plugin
export default {"feeDetailsCard":"Overview_feeDetailsCard__s54P1","feeCategory":"Overview_feeCategory__KxrK0","feeDetail":"Overview_feeDetail__yBl7M","wrapper":"Overview_wrapper__JHnSQ"};